/*
 * Whether "who is your manager?" was put off for this visit: "Later", or a
 * visit that went through onboarding. Kept per tab, so the next visit asks
 * again. Storage can throw in a locked-down browser; then it is asked again.
 */

const STORAGE_KEY = 'wundo.managerQuestion.postponed';

export function managerQuestionPostponed(): boolean {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function postponeManagerQuestion(): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, 'true');
  } catch {
    /* Asked again on the next page load. */
  }
}
